/**
 * Status Mapping-related GraphQL queries
 * CCM, RPM status options and enrollment attempts
 */

export const STATUS_QUERIES = {
  // Status Mapping queries
  GET_CCM_STATUS_OPTIONS_GLOBAL: `
    query GetCCMStatusOptionsGlobal {
      pep_v2_status_mapping_ccm(where: {global: {_eq: true}}, order_by: {id: asc}) {
        id
        status
      }
    }
  `,

  GET_CCM_STATUS_OPTIONS_CS: `
    query GetCCMStatusOptionsCS {
      pep_v2_status_mapping_ccm(where: {cs: {_eq: true}}, order_by: {id: asc}) {
        id
        status
      }
    }
  `,

  GET_CCM_STATUS_OPTIONS_PES: `
    query GetCCMStatusOptionsPES {
      pep_v2_status_mapping_ccm(where: {pes: {_eq: true}}, order_by: {id: asc}) {
        id
        status
      }
    }
  `,

  GET_CCM_STATUS_OPTIONS_VPE: `
    query GetCCMStatusOptionsVPE {
      pep_v2_status_mapping_ccm(where: {vpe: {_eq: true}}, order_by: {id: asc}) {
        id
        status
      }
    }
  `,

  GET_RPM_STATUS_OPTIONS: `
    query GetRPMStatusOptions {
      pep_v2_status_mapping_rpm(where: {global: {_eq: true}}, order_by: {id: asc}) {
        id
        status
      }
    }
  `,

  GET_RPM_STATUS_OPTIONS_CS: `
    query GetRPMStatusOptionsCS {
      pep_v2_status_mapping_rpm(where: {global: {_eq: true}}, order_by: {id: asc}) {
        id
        status
      }
    }
  `,

  GET_RPM_STATUS_OPTIONS_PES: `
    query GetRPMStatusOptionsPES {
      pep_v2_status_mapping_rpm(where: {pes: {_eq: true}}, order_by: {id: asc}) {
        id
        status
      }
    }
  `,

  // Status Updates queries
  GET_CCM_STATUS_UPDATES: `
    query GetCCMStatusUpdates($patientId: Int!) {
      pep_vw_consolidated_data(where: {patient_clinic_data_id: {_eq: $patientId}}) {
        ccm_status_updates
        patient_clinic_timezone
      }
    }
  `,

  GET_RPM_STATUS_UPDATES: `
    query GetRPMStatusUpdates($patientId: Int!) {
      pep_vw_consolidated_data(where: {patient_clinic_data_id: {_eq: $patientId}}) {
        rpm_status_updates
        patient_clinic_timezone
      }
    }
  `,

  GET_RPM_STATUS_UPDATES_DETAILED: `
    query GetRPMStatusUpdates($patientClinicDataId: Int!) {
      pep_vw_patient_rpm_status_updates(where: {patient_clinic_data_id: {_eq: $patientClinicDataId}}) {
        id
        status
        comment
        user_id
        timestamp
        updated_by
      }
    }
  `,

  // Patient consolidated data for status (unique query)
  GET_PATIENT_CONSOLIDATED_DATA_STATUS: `
    query MyQuery($patientId: Int!) {
      pep_vw_consolidated_data(where: {patient_clinic_data_id: {_eq: $patientId}}) {
        ccm_status_updates
        rpm_status_updates
        patient_clinic_timezone
      }
    }
  `
};